"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleItem = void 0;
var handler_1 = require("../handler");
var RuleItem = /** @class */ (function () {
    function RuleItem(ruleItem, pattern, handler, options) {
        this.ruleItem = ruleItem;
        this.pattern = pattern;
        this.handler = handler;
        this.options = options;
    }
    RuleItem.build = function (ruleItem) {
        var _a, _b;
        var _c = ruleItem.test.split('/').filter(function (el) { return !!el; }), regEx = _c[0], flags = _c[1];
        return new RuleItem(ruleItem, new RegExp(regEx, flags), handler_1.HandlerMapping.getByName((_a = ruleItem === null || ruleItem === void 0 ? void 0 : ruleItem.use) === null || _a === void 0 ? void 0 : _a.handler), ((_b = ruleItem === null || ruleItem === void 0 ? void 0 : ruleItem.use) === null || _b === void 0 ? void 0 : _b.options) || {});
    };
    return RuleItem;
}());
exports.RuleItem = RuleItem;
//# sourceMappingURL=RuleItem.js.map